var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{attrs:{"data-address":"dataItem.address","title":_vm.formatAddressForTitle(_vm.dataItem.address)}},[_vm._v(" "+_vm._s(_vm.formatAddress(_vm.dataItem.address))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }